<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      selected-product="cso"
      :product-options="productOptions"
      :filter-names="filterNames"
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <template v-slot:id="{ item }">
        <div class="d-flex align-center">
          <status-badge :status="item.connectivity_status" />
          <span>
            {{ item.charge_point_id }}
            {{ item.connector_id ? `/${item.connector_id}` : "" }}
          </span>
        </div>
      </template>
      <template v-slot:power_type="{ item }">
        <span class="text-uppercase">{{ item.power_type }}</span>
      </template>
      <template v-slot:connector_state="{ item }">
        <span class="text-capitalize">
          {{
            item.connectivity_status == "offline"
              ? "offline"
              : item.connector_state
          }}
        </span>
      </template>
      <template v-slot:actions="{ item }">
        <span>
          <GenerateQRCode
            :item="{
              charge_point_id: item.charge_point_id,
              connector_id: item.connector_id,
            }"
          />
        </span>
      </template>

      <!-- <template #addFilters> </template> -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- <template #actionModals>
        
      </template> -->
      <!-- Action Dialog -->
      <!-- <v-dialog v-model="dialog" max-width="800px">
        <start-transtions :customer-data="selectedRow"/>
      </v-dialog> -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";

import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    refreshButton: () =>
      import("../../../../components/base/RefreshButton.vue"),
    StatusBadge: () => import("@/components/base/Status-Badge.vue"),
    GenerateQRCode: () => import("@/components/base/GenerateQRCode.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      customerAdd: true,
      tableView: false,
      dialog: false,
      searchQuery: "",
      selectedCustomer: null,
      customerData: [],
      headers: [
        { text: "", value: "checkbox", align: "start" },
        { text: "Customer Name", value: "name" },
        { text: "Phone", value: "phone" },
        { text: "Email", value: "email" },
        { text: "Vehicle", value: "vehicle" },
        { text: "Booking Time", value: "bookingTime" },
      ],

      filters: {},
      subFilters: {},
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],

      itemData: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "csmsChargeStations/getLoading",
      meta: "csmsChargeStations/getConnectorMeta",
      list: "csmsChargeStations/getConnectorlist",
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("connector_id"),
          align: "left",
          sortable: true,
          value: "id",
        },

        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
        },
        {
          text: this.$t("location"),
          align: "left",
          sortable: false,
          value: "location_name",
        },
        // {
        //   text: this.$t("charge_stations"),
        //   align: "left",
        //   sortable: false,
        //   value: "charge_station",
        // },
        {
          text: this.$t("connector_type"),
          align: "left",
          sortable: false,
          value: "connector_type",
        },
        {
          text: this.$t("connector_format"),
          align: "left",
          sortable: false,
          value: "connector_format",
        },
        {
          text: this.$t("power_type"),
          align: "left",
          sortable: false,
          value: "power_type",
        },
        // {
        //   text: this.$t("power"),
        //   align: "left",
        //   sortable: false,
        //   value: "power",
        // },
        {
          text: this.$t("connector_state"),
          align: "left",
          sortable: false,
          value: "connector_state",
        },
        // {
        //   text: this.$t("unavailability_reason"),
        //   align: "left",
        //   sortable: false,
        //   value: "unavailability_reason",
        // },
        {
          text: this.$t("last_updated_at"),
          align: "left",
          sortable: true,
          value: "updated_at",
        },
        {
          text: this.$t("actions"),
          align: "left",
          sortable: true,
          value: "actions",
        },
      ];
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },
    transactionHeader() {
      const headers = [
        { text: "", value: "checkbox", align: "start" },
        { text: "Customer Name", value: "name" },
        { text: "Phone", value: "phone" },
        { text: "Email", value: "email" },
        { text: "Vehicle", value: "vehicle" },
        { text: "Booking Time", value: "bookingTime" },
      ];
      return headers;
    },

    filterNames() {
      return ["location_city", "locations", "charge_point"];
    },
  },
  watch: {
    "options.tenant_id": {
      handler: function () {},
    },
    options() {
      this.fetchData();
    },
  },
  async mounted() {},
  beforeDestroy() {
    const paramsset = { ...this.options };
    paramsset.location_id = this.location;
    const params = {
      name: "generateQRCode",
      filters: paramsset,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    openDialog(val) {
      this.dialog = true;
      this.customerAdd = false;
      this.tableView = false;
      this.searchQuery = "";
      this.customerData = []; // Reset data
      this.selectedCustomer = null; // Clear selection
      this.itemData = val; // Clear selection
    },

    async fetchData() {
      const params = { ...this.options };
      await this.$store
        .dispatch("csmsChargeStations/connectorlist", params)
        .then(() => {
          if (this.options.page > (this.meta?.lastPage || 1)) {
            this.options.page = 1;
          }
        });
    },

    //
    startAction() {
      // Start Action
    },
    closeDialog() {
      this.dialog = false;
      this.customerAdd = false;
      this.tableView = false;
      this.searchQuery = "";
      this.customerData = [];
      this.selectedCustomer = null;
      this.itemData = null; // Clear selection
    },
  },
};
</script>
